<app-form-min-commerces ></app-form-min-commerces>
<div class="d-flex">
  <div class="col-12 my-1">
    <button id="create-variable" class="btn btn-indigo float-right" type="submit" (click)="create()">
      <span>
        Ajouter un Commerce
      </span>
    </button>
  </div>
</div>
<div class="basic-container" style="margin-top: 10px;">
  <table mat-table matSort [dataSource]="commerces" multiTemplateDataRows
  (matSortChange)="sortData($event)"
  multiTemplateDataRows class="mat-elevation-z8">
  <ng-container matColumnDef="expandIcon">
    <th mat-header-cell *matHeaderCellDef> </th>

    <td mat-cell *matCellDef="let element">
      <div class="flex-nowrap form-inline">
        <mat-icon (click)="expandedElement = expandedElement === element ? null : element">
          {{expandedElement === element ? 'expand_less' : 'expand_more'}}
        </mat-icon>
      </div>
    </td>
  </ng-container>
    <ng-container matColumnDef="companyName">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Nom </th>
      <td mat-cell *matCellDef="let element">
      <span >
          {{element.companyName}}
      </span>
    </td>
    </ng-container>
    <ng-container matColumnDef="city">
      <th mat-header-cell mat-sort-header  *matHeaderCellDef> Ville </th>
      <td mat-cell *matCellDef="let element"> {{element.city}} </td>
    </ng-container>
    <ng-container matColumnDef="cp">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Code postal </th>
      <td mat-cell *matCellDef="let element">
      <span >
          {{element.cp}}
      </span>
    </td>
    </ng-container>

    <ng-container matColumnDef="creditTime">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Credit Temps </th>
      <td mat-cell *matCellDef="let element"> {{element.creditBalance > 0 ? element.creditBalanceFormated: 0}} </td>
    </ng-container>
    <ng-container matColumnDef="tel1">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> Telephone </th>
      <td mat-cell *matCellDef="let element"> {{element.tel1}} </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">
        <div class="buttons">
          <div class="m-2">
            <span (click)="offer(element)">
              <i class="fa fa-bullhorn text-info" style="cursor: pointer;" aria-hidden="true"
                title="Annoncer une Offre"></i>
            </span>
          </div>
          <div class="m-2">
            <span (click)="edit(element)">
              <i class="fa fa-pencil-square-o text-primary" style="cursor: pointer;" aria-hidden="true"
                title="Editer"></i>
            </span>
          </div>
          <div class="m-2">
            <span (click)="openDeleteConfirm(element.id)">
              <i class="fa fa-trash-o text-danger" style="cursor: pointer;" aria-hidden="true" title="Supprimer"></i>
            </span>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
        <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div class="example-element-descriptions">
            <div>
              <div class="example-element-description">
                  <div class="example-element-description__header">
                      <div class="example-element-description__cell"> Telephone </div>
                      <div class="example-element-description__cell"> Email </div>
                      <div class="example-element-description__cell"> Contact </div>
                      <div class="example-element-description__cell"> Adresse </div>
                  </div>
                  <div class="example-element-description__content">
                      <div class="example-element-description__cell">
                        <span>{{element['tel1']}}</span>&nbsp;<span>{{element['tel2']}}</span>
                      </div>
                      <div class="example-element-description__cell">
                        <span>{{element['email']}}</span>
                      </div>
                      <div class="example-element-description__cell">
                        <span>{{element['contactName']}}</span>
                      </div>
                      <div class="example-element-description__cell">
                        <span>{{element['adress']}}</span>&nbsp;<span>{{element['cp']}}</span>&nbsp;<span>{{element['city']}}</span>
                      </div>
                </div>
              </div>
              </div>
            </div>
          </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row "
    [class.example-expanded-row]="expandedElement === element"
    (click)="expandedElement = expandedElement === element ? null : element" >
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>
</div>
